import React from "react";
import { ReactNode } from "react";
import ObservableState from "../utils/ObservableState";
import * as ui from "../native";
import ObservableComponent from "./ObservableComponent";
import BaseUIProps, { copyBaseUIProps } from "../native/ui/BaseUIProps";
import MaterialIcons from "../icons/MaterialIcons";
import TextView from "./TextView";
import IconView from "./IconView";
import { BuildContext } from "../classes/BuildContext";

export interface CollapseViewProps extends BaseUIProps {
  key?: string;
  title?: string;
  subTitle?: string;
  content?: ReactNode;
  button?: ReactNode;
}

class _CollapseViewState extends ObservableComponent<CollapseViewProps> {
  static defaultProps = { title: "", subTitle: "" };
  collapse: boolean = false;
  static contextType = BuildContext;
  context: React.ContextType<typeof BuildContext>;
  public constructor(props: CollapseViewProps) {
    super(props);

    this.initState();
  }
  public get title(): string {
    return this.props.title;
  }
  public get subTitle(): string {
    return this.props.subTitle;
  }
  public initState() {
    super.initState();

    this.initListeners();

    this.enableBuild = true;
  }
  public initListeners(): void {
    this.on(["collapse", "subTitle", "title"], this.rebuild);
  }
  public componentDidUpdate(prevProps: CollapseViewProps): void {
    super.componentDidUpdate(prevProps);

    if (prevProps.title !== this.props.title) {
      this.fire("title", this);
    }

    if (prevProps.subTitle !== this.props.subTitle) {
      this.fire("subTitle", this);
    }
  }
  public setCollapse(val: boolean): void {
    let isValChanged: boolean = this.collapse !== val;

    if (!isValChanged) {
      return;
    }

    this.collapse = val;

    this.fire("collapse", this);
  }
  public render(): ReactNode {
    let cStyle = this.context.theme;

    return ui.Column({
      crossAxisAlignment: ui.CrossAxisAlignment.start,
      children: [
        ui.Row({
          mainAxisAlignment: ui.MainAxisAlignment.spaceBetween,
          children: [
            ui.Row({
              children: [
                IconView({
                  icon: this.collapse
                    ? MaterialIcons.expand_less
                    : MaterialIcons.keyboard_arrow_down,
                  size: 20,
                  color: cStyle.c22,
                  className: "xc2d",
                  key: "0",
                }),
                TextView({
                  data: this.title,
                  style: new ui.TextStyle({
                    fontFamily: cStyle.tTextViewNameTextFontFamilyOn,
                    color: cStyle.tTextViewNameTextColorOn,
                    fontSize: cStyle.tTextViewNameTextFontSizeOn,
                    fontWeight: cStyle.tTextViewNameTextFontWeightOn,
                  }),
                  key: "1",
                }),
                TextView({
                  data: this.subTitle.isEmpty ? "" : "(" + this.subTitle + ")",
                  style: new ui.TextStyle({ color: cStyle.c12, fontSize: 12 }),
                  className: "x51",
                  key: "2",
                }),
              ],
              key: "0",
            }),
            ui.Row({
              children: [ui.Container({ child: this.props.button, key: "0" })],
              key: "1",
            }),
          ],
          onTap: (e) => {
            e.stopPropagation();

            this.onTapRowBehaviourHandler();
          },
          className: "x42 hc h",
          key: "0",
        }),
        this.collapse
          ? ui.Container({ child: this.props.content, className: "x1f0 hc h" })
          : [],
      ],
      className: ui.join(this.props.className, "CollapseView x29e hc h"),
      ...copyBaseUIProps(this.props),
    });
  }
  public onTapRowBehaviourHandler = (): void => {
    this.setCollapse(!this.collapse);
  };
  public get contentPresent(): boolean {
    return this.props.content != null;
  }
  public get content(): ReactNode {
    return this.props.content;
  }
  public get buttonPresent(): boolean {
    return this.props.button != null;
  }
  public get button(): ReactNode {
    return this.props.button;
  }
}
export default function CollapseView(props: CollapseViewProps) {
  return React.createElement(_CollapseViewState, {
    ..._CollapseViewState.defaultProps,
    ...props,
  });
}
